import { Grid, Container } from '@mui/material';
import { Typography, useTheme } from '@mui/material';
import "./pages.css";
import ContentBox from '../components/contentBox';
import { MEDIUM_BLOGS } from '../content/blogList';

function Blogs() {
    const theme = useTheme();

    return(
      <Container sx={{ width: '100%', height: '100%' }} maxWidth="lg">    
        <Grid container columns={{xs: 4, sm: 8, md: 12}} spacing={2} justifyContent='center'>
            <Grid container xs={12} sx={{ width: '100%', height: '200px', display: 'flex', flexDirection: 'column' }}>
                <Typography variant='h1' style={{ fontSize: theme.typography.title1.fontSize, marginTop: 'auto' }} textAlign='center'>
                    RIO BLOGS
                </Typography>
            </Grid>
            <Grid item xs={12} marginBottom={10}>
                <Typography variant="body1" textAlign="center" style={{ 
                    fontSize: theme.typography.subtitle1.fontSize, 
                    fontFamily: theme.typography.subtitle1.fontFamily, 
                    fontWeight: theme.typography.subtitle1.fontWeightThin,
                    letterSpacing: '2px'
                }}>
                    Read all Rio's blogs
                </Typography>
            </Grid>
            {MEDIUM_BLOGS.map(item => (
                item.isHighlighted ? (
                    <Grid item xs={12}>
                        <ContentBox
                            title={item.title}
                            releaseDate={item.releaseDate}
                            author='Rio Dwi Putra'
                            color={item.color}
                            isHighlight={true}
                            link={item.link}
                        />
                    </Grid>
                ) : (
                    <Grid item xs={12} md={6}>
                        <ContentBox
                            title={item.title}
                            releaseDate={item.releaseDate}
                            author='Rio Dwi Putra'
                            color={item.color}
                            isHighlight={false}
                            link={item.link}
                        />
                    </Grid>
                )
            ))}
        </Grid>
      </Container>
    )
}

export default Blogs